import { computed, watch, type Ref } from 'vue'
import {
  type GatTextEditProps,
  type GatTextEditModelValue,
  type GatTextEditEmits
} from './gat-text-edit.vue'

export function updateGatTextEditValue(
  value: GatTextEditModelValue,
  lowerCase = false,
  upperCase = false
): GatTextEditModelValue {
  let newValue = value
  if (newValue) {
    // To upper case
    if (upperCase) {
      newValue = newValue.toUpperCase()
    }
    if (lowerCase) {
      newValue = newValue.toLowerCase()
    }
  } else {
    // If it is an empty string, return null (for database purposes)
    newValue = undefined
  }
  return newValue
}

export function useTextEditModelValue(
  props: GatTextEditProps,
  emit: GatTextEditEmits,
  defaultValue?: GatTextEditModelValue
  // customLowerCase: ComputedRef<boolean>,
  // customUpperCase: ComputedRef<boolean>
) {
  const gatLowerCase = computed(
    () => /* customLowerCase.value || */ props.lowerCase
  )
  const gatUpperCase = computed(
    () => /* customUpperCase.value || */ props.upperCase
  )

  const textEditValue = computed({
    get: () => props.modelValue ?? defaultValue,
    set: (value) => {
      const newValue = updateGatTextEditValue(
        value,
        gatLowerCase.value,
        gatUpperCase.value
      )
      if (
        newValue !== props.modelValue &&
        (typeof newValue === 'string' || newValue === undefined)
      ) {
        emit('update:modelValue', newValue)
      }
    }
  })

  watch(
    () => gatLowerCase.value,
    () => {
      textEditValue.value = updateGatTextEditValue(textEditValue.value)
    },
    {
      immediate: true
    }
  )
  watch(
    () => gatUpperCase.value,
    () => {
      textEditValue.value = updateGatTextEditValue(textEditValue.value)
    },
    {
      immediate: true
    }
  )

  return {
    textEditValue
  }
}
